<template>
	<div v-if="values" class="element el-bar-dash-chart" :class="{ 'can-change': is_editable }">
		<div class="bar-dash-chart">
			<div v-for="item in values" :key="item.label" class="bar-dash">
				<div class="bar-dash-label">{{ item.label }}</div>
				<div class="bar-dash-dashes">
					<div v-for="i in get_value(item)" :key="i" class="dash" :class="get_dash_color(i)"></div>
				</div>
				<div class="bar-dash-value">{{ display_value(item.value) }}</div>
			</div>
			<div class="bar-dash-legends">
				<span class="bar-legend"><span class="color green"></span> Rapide</span>
				<span class="bar-legend"><span class="color orange"></span> Moyen</span>
				<span class="bar-legend"><span class="color red"></span> Lent</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-bar-dash-chart",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		values: Array
	},
	computed: {
		...mapGetters([ ])
	},
	methods: {
		get_value (item) {
			const MAX = 24;

			if (isNaN(item.value)) {
				return 0;
			}
			if (item.value < MAX)
				return item.value;
			if (item.value > 99)
				return MAX -2;
			return MAX;
		},
		get_dash_color: function (i) {
			if (i < 15) return "green";
			if (i < 20) return "orange";
			return "red";
		},
		display_value (value) {
			const v = parseInt(value);
			if (isNaN(v)) {
				return "-";
			}
			return v + " mois";
		},
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.el-bar-dash-chart
	> .bar-dash-chart
		display block
		margin 8px 0
		text-align left
		> .bar-dash
			display block
			width 100%
			height 15px
			margin 0 0 6px 0
			font-weight bold
			.bar-dash-label
				position absolute
				left 0
				top 0
				width 32px
				line-height @height
			.bar-dash-dashes
				float left
				margin-left 32px
				height 100%
				// background-color #eee
				.dash
					float left
					width 5px
					height 100%
					margin 0 3px 0 0
					background #eee
					// border-radius 2px
					&.green
						background green
					&.orange
						background orange
					&.red
						background red
			.bar-dash-value
				float left
				margin 0 0 0 4px
				font-size 10px
				line-height 16px
				color #999
		.bar-dash-legends
			position absolute
			left 8px
			right 0
			bottom -24px
			line-height 16px
			font-size 9px
			.bar-legend
				float left
				margin 0 12px 0 0
				.color
					float left
					width 8px
					height 8px
					margin 4px 4px 0 0
					background-color #eee
					border-radius 100%
					&.green
						background-color green
					&.orange
						background-color orange
					&.red
						background-color red

</style>